var exports = {
  "Tt": "xe533113f--05b39f--offer-header",
  "x5": "xe533113f--05b39f--with-discount",
  "q9": "xe533113f--05b39f--price",
  "mr": "xe533113f--05b39f--highlighted",
  "lp": "xe533113f--05b39f--additional-price-info",
};

module.exports = exports;
